(function () {
if (!customElements.get("lsg-header")) customElements.define("lsg-header", class LSGHeader extends HTMLElement {
    constructor(){
        super();
        this.selectors = {
            navbar: ".js-lsg-header-navbar",
            triggerContainer: ".lsg-header__desk-menu .js-lsg-header-trigger-container",
            toggleButton: ".js-lsg-header-toggle-button",
            triggerContainerMob: ".lsg-header__mobile-menu .js-lsg-header-trigger-container",
            mobileMenuToggle: ".js-toggle-menu",
            overlay: ".js-lsg-header-overlay",
            header: ".js-lsg-header-wrap"
        };
        this.mouseOutTimer; // timer used to delay hiding of menu after mouse leaves
        this.mouseOutHideDelay = 300; // time (in ms) before menu is closed after mouse leaves
        this.header = document.querySelector(this.selectors.header);
        this.navbar = this.querySelector(this.selectors.navbar);
        this.overlay = this.querySelector(this.selectors.overlay);
        this.triggerContainer = document.querySelectorAll(this.selectors.triggerContainer);
        this.toggleButtons = this.querySelectorAll(this.selectors.toggleButton);
        this.triggerContainerMob = document.querySelectorAll(this.selectors.triggerContainerMob);
        this.mobileMenuToggle = document.querySelectorAll(this.selectors.mobileMenuToggle);
        this.init();
        this.setWidth();
        window.addEventListener("resize", ()=>{
            this.setWidth();
        });
    }
    setWidth() {
        const doc = document.querySelector("body");
        doc.style.setProperty("--lsg-window-width", `${window.innerWidth}px`);
    }
    hideMobMenu(el) {
        document.querySelector(".js-lsg-header-mobile-menu").classList.remove("is-open");
        el.setAttribute("aria-expanded", false);
        document.querySelector("body").classList.remove("is-mob-menu-open");
    }
    showMobMenu(el) {
        el.setAttribute("aria-expanded", true);
        document.querySelector(".js-lsg-header-mobile-menu").classList.add("is-open");
        document.querySelector("body").classList.add("is-mob-menu-open");
    }
    init() {
        if (this.header != null) window.addEventListener("scroll", ()=>{
            const currentScroll = document.documentElement.scrollTop || document.body.scrollTop;
            if (currentScroll > 40) this.header.classList.remove("is-on-the-top");
            else this.header.classList.add("is-on-the-top");
        });
        this.mobileMenuToggle.forEach((el)=>{
            el.addEventListener("click", (e)=>{
                if (el.getAttribute("aria-expanded") == "true") this.hideMobMenu(el);
                else this.showMobMenu(el);
            });
        });
        // Show the menu on mouse hover of the trigger
        this.triggerContainer.forEach((el)=>{
            el.addEventListener("mouseover", (e)=>{
                this.showMenu(el);
                clearTimeout(this.mouseOutTimer);
            });
            // Hide the menu when mouse hover leaves both the trigger and menu fly-out, but only after a short delay to help people jerky mouse movements (like those using head/eye trackers)
            el.addEventListener("mouseout", (e)=>{
                this.mouseOutTimer = setTimeout(()=>{
                    this.hideElMenu(el);
                }, this.mouseOutHideDelay);
            });
            // Toggle the menu when the trigger is activated
            el.querySelector(this.selectors.toggleButton).addEventListener("click", ()=>{
                this.toggleMenu(el);
            });
        });
        // Show the menu on mouse hover of the trigger
        this.triggerContainerMob.forEach((el)=>{
            // Toggle the menu when the trigger is activated
            el.querySelector(this.selectors.toggleButton).addEventListener("click", ()=>{
                this.toggleMenu(el);
            });
        });
        // Hide the menu when the user tabs out of it
        this.triggerContainer.forEach((el)=>{
            el.addEventListener("keydown", (e)=>{
                this.triggerKeydownHandler(e, el);
            });
        });
        // // Close the menu when the close button is clicked
        // this.closeButton.addEventListener('click', hideMenu);
        //
        // // Close the menu AND return focus to the trigger when the close button is activted by keyboard
        // this.closeButton.addEventListener('keydown', function(e) {
        //     if(e.key == 'Enter' || e.key == ' ') {
        //         e.preventDefault();
        //         hideMenu();
        //         this.toggleButton.focus();
        //     }
        // });
        //
        // Close the menu when the user activates something outside the this.navbar.
        document.body.addEventListener("click", (e)=>{
            this.handleBodyClick(e);
        });
    }
    /**
     Menu visibility
     */ showMenu(el) {
        this.hideMenu();
        el.querySelector(this.selectors.toggleButton).setAttribute("aria-expanded", true);
        el.classList.add("is-show-sub-menu");
        this.overlay.classList.add("is-show-sub-menu");
        document.querySelector("body").classList.add("is-show-mega-menu");
        setTimeout(()=>{
            el.querySelector(this.selectors.toggleButton).setAttribute("aria-expanded", true);
            el.classList.add("is-show-sub-menu");
            this.overlay.classList.add("is-show-sub-menu");
            document.querySelector("body").classList.add("is-show-mega-menu");
        }, 10);
    }
    hideElMenu(el) {
        el.querySelector(this.selectors.toggleButton).setAttribute("aria-expanded", false);
        el.classList.remove("is-show-sub-menu");
        document.querySelector("body").classList.remove("is-show-mega-menu");
        this.overlay.classList.remove("is-show-sub-menu");
    }
    hideMenu() {
        this.toggleButtons.forEach((btn)=>{
            btn.setAttribute("aria-expanded", false);
        });
        this.triggerContainer.forEach((el)=>{
            el.classList.remove("is-show-sub-menu");
        });
        this.triggerContainerMob.forEach((el)=>{
            el.classList.remove("is-show-sub-menu");
        });
        this.overlay.classList.remove("is-show-sub-menu");
    }
    toggleMenu(el) {
        console.log(el.querySelector(this.selectors.toggleButton).getAttribute("aria-expanded"));
        if (el.querySelector(this.selectors.toggleButton).getAttribute("aria-expanded") == "true") this.hideMenu(el);
        else this.showMenu(el);
    }
    /**
     Event handlers
     */ handleBodyClick(e) {
        // Hide the menu if the user clicks anywhere other than on the this.navbar or one of it's child menus
        if (!this.navbar.contains(e.target)) this.hideMenu();
    }
    triggerKeydownHandler(e, el) {
        const lastMenuItems = el.querySelectorAll("a, button");
        const lastMenuItem = lastMenuItems[lastMenuItems.length - 1];
        // Hide the menu a keyboard user tabs out of it
        if (e.key === "Tab" && !e.shiftKey && e.target === lastMenuItem || e.key == "Escape") {
            this.hideElMenu(el);
            // Move focus back to the menu toggle button if Escape was pressed
            if (e.key == "Escape") el.querySelector(this.selectors.toggleButton).focus();
        }
    }
});
if (!customElements.get("mega-menu")) customElements.define("mega-menu", class megaMenu extends HTMLElement {
    constructor(){
        super();
        this.selectors = {
            navItem: ".js-header-sub-wrapper",
            navItemMob: ".lsg-header__mobile-menu .js-header-sub-wrapper",
            desktopMegaMenu: ".js-mega-menu-mobile-desktop"
        };
        this.body = document.querySelector("body");
        this.dataParentLink = this.getAttribute("data-parent-link");
        this.navItem = document.querySelector(`${this.selectors.navItem}[data-navlink-handle="${this.dataParentLink}"]`);
        this.desktopMegaMenu = this.querySelector(this.selectors.desktopMegaMenu);
        this.navItemMob = document.querySelector(`${this.selectors.navItemMob}[data-navlink-handle="${this.dataParentLink}"]`);
        this.init();
    }
    setMegaMenuHeight() {
        document.querySelectorAll(".js-mega-menu-sub-toggle.is-active").forEach((activeEl)=>{
            const el = activeEl.parentNode.querySelector(".js-mega-menu-column");
            if (el != null) activeEl.closest(".lsg-mega-menu__grid").style.minHeight = `${el.offsetHeight}px`;
        });
    }
    initMegaMenu() {
        this.navItem.classList.add("has-mega-menu");
        this.navItem.innerHTML = "";
        this.navItem.append(this.desktopMegaMenu);
        this.mobMegaMenu = this.desktopMegaMenu.cloneNode(true);
        if (this.navItemMob != null) {
            this.navItemMob.classList.add("has-mega-menu");
            this.navItemMob.innerHTML = "";
            this.navItemMob.append(this.mobMegaMenu);
            this.navItemMob.querySelectorAll(".js-mega-menu-sub-toggle").forEach((el)=>{
                el.classList.add("js-mega-menu-sub-mob-toggle");
                el.classList.remove("js-mega-menu-sub-toggle");
                el.setAttribute("aria-expanded", false);
            });
        }
        const self = this;
        document.querySelectorAll(".js-mega-menu-sub-toggle").forEach((item)=>{
            var element = document.querySelector('.js-mega-menu-column[data-value="' + item.getAttribute("data-value") + '"]');
            if (item.closest(".header--menu") != null) {
                item.removeAttribute("aria-expanded");
                item.removeAttribute("aria-controls");
            }
            function showSubMenu(element, item) {
                document.querySelectorAll(".js-mega-menu-column.is-active").forEach((activeEl)=>{
                    activeEl.classList.remove("is-active");
                });
                document.querySelectorAll(".js-mega-menu-sub-toggle.is-active").forEach((activeEl)=>{
                    activeEl.classList.remove("is-active");
                // activeEl.setAttribute('aria-expanded', false);
                });
                if (element != null) element.classList.add("is-active");
                item.classList.add("is-active");
                // item.setAttribute('aria-expanded', true);
                self.setMegaMenuHeight();
            }
            item.addEventListener("mouseover", (e)=>{
                e.preventDefault();
                showSubMenu(element, item);
            });
            if (element != null) item.addEventListener("click", (e)=>{
                e.preventDefault();
                showSubMenu(element, item);
            });
        });
        document.querySelectorAll(".js-mega-menu-sub-mob-toggle").forEach((el)=>{
            el.classList.remove("is-active");
            el.parentNode.querySelector(".lsg-mega-menu__grid").classList.remove("is-active");
            el.addEventListener("click", (e)=>{
                if (el.classList.contains("is-active")) document.querySelectorAll(".js-mega-menu-sub-mob-toggle.is-active").forEach((item)=>{
                    item.classList.remove("is-active");
                    item.parentNode.querySelector(".lsg-mega-menu__grid").classList.remove("is-active");
                    item.setAttribute("aria-expanded", false);
                });
                else {
                    document.querySelectorAll(".js-mega-menu-sub-mob-toggle.is-active").forEach((item)=>{
                        item.classList.remove("is-active");
                        item.parentNode.querySelector(".lsg-mega-menu__grid").classList.remove("is-active");
                    });
                    el.classList.toggle("is-active");
                    el.parentNode.querySelector(".lsg-mega-menu__grid").classList.toggle("is-active");
                    el.setAttribute("aria-expanded", true);
                }
            });
        });
    }
    init() {
        if (this.navItem != null) this.initMegaMenu();
    }
});

})();
